import React from "react";
import ReactDOM from "react-dom";
import { Message } from "./Message";

const cookiePlaceholders = document.querySelectorAll(
  "[data-cookiebot-marketing-placeholder]"
);

if (cookiePlaceholders) {
  [...cookiePlaceholders].forEach((placeholderElem) => {
    ReactDOM.render(<Message />, placeholderElem);
  });
}
